import React from 'react';

import styles from './UseLeash.module.scss';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslate } from 'react-polyglot';
import LineGraphCard from '../../../Cards/LineGraphCard/LineGraphCard';
import { useAuth } from '../../../../../../Auth';
import { useAxios } from '../../../../../../AxiosHandler';
import OnLeashPrizeCountGraph from './OnLeashPrizeCountGraph/OnLeashPrizeCountGraph';

function UseLeash(props: UseLeashProps) {
    const t = useTranslate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [data, setData] = React.useState<any>();

    const options = {
        scales: {
            y: {
                suggestedMin: 0,
                suggestedMax: 10
            }
        },
        plugins: {
            legend: {
                display: false
            }
        }
    };

    function getData() {
        if (auth.selectedBreed == undefined) return;

        const requests = [
            {
                method: 'get',
                url: "/api/statistics/use/leash/" + auth.selectedBreed + "/ebv",
                responseType: 'json',
                headers: {'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all"}
            },
            {
                method: 'get',
                url: "/api/statistics/use/leash/" + auth.selectedBreed + "/phenotype",
                responseType: 'json',
                headers: {'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all"}
            },
            {
                method: 'get',
                url: "/api/statistics/use/leash/" + auth.selectedBreed + "/tests",
                responseType: 'json',
                headers: {'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all"}
            }
        ];

        Promise.all(requests.map((request) => axios.single(request))).then((res) => {
            if (res[0].data?.length > 0 || res[1].data?.length > 0 || res[2].data?.length > 0) {

                setData({
                    fenotype: {
                        sumpoints: {
                            labels: res[1].data.map((item: any) => item.YEAR),
                            data: res[1].data.map((item: any) => item.SUMPOINTS)
                        },
                        M1: {
                            labels: res[1].data.map((item: any) => item.YEAR),
                            data: res[1].data.map((item: any) => item.M1)
                        },
                        M2: {
                            labels: res[1].data.map((item: any) => item.YEAR),
                            data: res[1].data.map((item: any) => item.M2)
                        },
                        M3: {
                            labels: res[1].data.map((item: any) => item.YEAR),
                            data: res[1].data.map((item: any) => item.M3)
                        },
                        M4: {
                            labels: res[1].data.map((item: any) => item.YEAR),
                            data: res[1].data.map((item: any) => item.M4)
                        },
                        M5: {
                            labels: res[1].data.map((item: any) => item.YEAR),
                            data: res[1].data.map((item: any) => item.M5)
                        },
                    },
                    avlsverdi: {
                        sumpoints: {
                            labels: res[2].data.map((item: any) => item.YEAR),
                            data: {
                                numdogs: res[2].data.map((item: any) => item.ANT_HUNDER),
                                numtests: res[2].data.map((item: any) => item.ANT_PROVER),
                                numfirsts: res[2].data.map((item: any) => item.ANT_FORSTEPREMIER)
                            }

                        },
                        M1: {
                            labels: res[0].data.map((item: any) => item.YEAR),
                            data: res[0].data.map((item: any) => item.AVERAGE_M1)
                        },
                        M2: {
                            labels: res[0].data.map((item: any) => item.YEAR),
                            data: res[0].data.map((item: any) => item.AVERAGE_M2)
                        },
                        M3: {
                            labels: res[0].data.map((item: any) => item.YEAR),
                            data: res[0].data.map((item: any) => item.AVERAGE_M3)
                        },
                        M4: {
                            labels: res[0].data.map((item: any) => item.YEAR),
                            data: res[0].data.map((item: any) => item.AVERAGE_M4)
                        },
                        M5: {
                            labels: res[0].data.map((item: any) => item.YEAR),
                            data: res[0].data.map((item: any) => item.AVERAGE_M5)
                        },
                    }
                });

                props.onDataLoaded?.(true);
            } else {
                setData(undefined);
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    React.useEffect(() => {
        if (auth.selectedBreed != undefined) {
            props.onDataLoaded?.(false);
            getData();
        }
    }, [auth.selectedBreed, auth.selectedCountry]);

    return (
        <div className={styles.statisticsuseleash}>
            <Container className={styles.container}>
                <Row className={styles.row}>
                    <Col sm="12" md="6" className={styles.col}>
                        <LineGraphCard
                            data={{
                                labels: data?.fenotype.sumpoints.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.fenotype.sumpoints.data,
                                    tension: 0.3
                                }]
                            }}
                            options={{
                                scales: {
                                    y: {
                                        suggestedMin: 0,
                                        suggestedMax: 100
                                    }
                                },
                                plugins: {
                                    legend: {
                                        display: false
                                    }
                                }
                            }}
                            title={t("statistics.areas.use.leash.fenotype.sumpoints.graph.title")}
                        />
                    </Col>
                    <Col sm="12" md="6" className={styles.col}>
                        <LineGraphCard
                            data={{
                                labels: data?.avlsverdi.sumpoints.labels,
                                datasets: [
                                    {
                                        label: t("statistics.areas.use.leash.info.graph.numdogs"),
                                        backgroundColor: "transparent",
                                        pointBackgroundColor: "#68DB5A",
                                        borderColor: "#68DB5A",
                                        pointRadius: 2,
                                        data: data?.avlsverdi.sumpoints.data.numdogs,
                                        tension: 0.3
                                    },
                                    {
                                        label: t("statistics.areas.use.leash.info.graph.numtests"),
                                        backgroundColor: "transparent",
                                        pointBackgroundColor: "#DB5A5A",
                                        borderColor: "#DB5A5A",
                                        pointRadius: 2,
                                        data: data?.avlsverdi.sumpoints.data.numtests,
                                        tension: 0.3
                                    },
                                    {
                                        label: t("statistics.areas.use.leash.info.graph.numfirsts"),
                                        backgroundColor: "transparent",
                                        pointBackgroundColor: "#5A6ADB",
                                        borderColor: "#5A6ADB",
                                        pointRadius: 2,
                                        data: data?.avlsverdi.sumpoints.data.numfirsts,
                                        tension: 0.3
                                    }
                                ]
                            }}
                            options={{
                                scales: {
                                    y: {
                                        suggestedMin: 0,
                                        suggestedMax: 100
                                    }
                                },
                                plugins: {
                                    legend: {
                                        display: true
                                    }
                                }
                            }}
                            title={t("statistics.areas.use.leash.info.graph.title")}
                        />
                    </Col>
                    <Col sm="12" md="6" className={styles.col}>
                        <OnLeashPrizeCountGraph
                            
                        />
                    </Col>
                </Row>
            </Container>
            <hr/>
            <Container className={styles.container}>
                <Row className={styles.row}>
                    <Col sm="12" md="6" className={styles.col}>
                        <h3>{t("statistics.areas.use.leash.fenotype.title")}</h3>
                        <LineGraphCard
                            data={{
                                labels: data?.fenotype.M1.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.fenotype.M1.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.leash.fenotype.M1.graph.title")}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.fenotype.M2.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.fenotype.M2.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.leash.fenotype.M2.graph.title")}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.fenotype.M3.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.fenotype.M3.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.leash.fenotype.M3.graph.title")}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.fenotype.M4.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.fenotype.M4.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.leash.fenotype.M4.graph.title")}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.fenotype.M5.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.fenotype.M5.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.leash.fenotype.M5.graph.title")}
                        />
                    </Col>
                    <Col sm="12" md="6" className={styles.col}>
                        <h3>{t("statistics.areas.use.leash.avlsverdi.title")}</h3>
                        <LineGraphCard
                            data={{
                                labels: data?.avlsverdi.M1.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avlsverdi.M1.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={" "}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.avlsverdi.M2.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avlsverdi.M2.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={" "}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.avlsverdi.M3.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avlsverdi.M3.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={" "}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.avlsverdi.M4.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avlsverdi.M4.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={" "}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.avlsverdi.M5.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avlsverdi.M5.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={" "}
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

class UseLeashProps {
    onDataLoaded?: (data: any) => void;
}

export default UseLeash;